import { legalCategories } from '@common/components/LegalCategories/constants';

const prepareValueForComparison = (value: string) => value.replace(/\s/g, '').toLowerCase();

export const getLegalCategories = (value: string) => {
  return legalCategories.find((x) => prepareValueForComparison(x.value) === prepareValueForComparison(value))!.text;
};
